import React, {type JSX} from 'react';
import {Box, Typography} from '@mui/material';
import ReferenceCodeCard from './referenceCodeCard';
import {BlockContainer} from './shared';

function ReferenceCodeBlock(): JSX.Element {
  return (
    <BlockContainer withBorder>
      <>
        <Typography component="h1" variant="h3" align="center">
          Welcome to Health Bank Connect&trade;
        </Typography>
        <Box
          sx={theme => ({
            paddingTop: theme.spacing(8),
          })}
        >
          <ReferenceCodeCard />
        </Box>
      </>
    </BlockContainer>
  );
}

export default ReferenceCodeBlock;
